import { useState } from "react";

import { useUser } from "@/context/user";

import DateFilter from "@/components/filters/date";
import SortingFilters from "@/components/filters/sorting";
import TraineesFilter from "@/components/filters/trainees";

import { FiltersList } from "@/enums/dashboard";
import { Roles } from "@/enums/user";

import type { FiltersProps } from "./filters.types";

import { FiltersContainer } from "./filters.styles";

const Filters = ({
    variant,
    asInputField,
    onUserSelected,
    onDateChange,
    initialUserId,
    initialDateRange,
    dateRange,
    onSortingChange,
    sortingOption,
}: FiltersProps) => {
    const {
        state: { role },
    } = useUser();

    const isAdminOrInstructor = role === Roles.Instructor || role === Roles.Admin;

    const [filterOpen, setFilterOpen] = useState(FiltersList.None);

    return (
        <FiltersContainer>
            {isAdminOrInstructor && (
                <TraineesFilter
                    isOpen={FiltersList.TraineesList === filterOpen}
                    handleOnClick={(val: any) => setFilterOpen(val)}
                    onUserSelected={onUserSelected}
                    initialUserId={initialUserId}
                    variant={variant}
                    asInputField={asInputField}
                />
            )}
            <DateFilter
                isOpen={FiltersList.DatePicker === filterOpen}
                handleOnClick={(val: any) => setFilterOpen(val)}
                onChange={onDateChange}
                initialDateRange={initialDateRange}
                dateRange={dateRange}
                variant={variant}
                asInputField={asInputField}
            />
            <SortingFilters
                isOpen={FiltersList.OrderBy === filterOpen}
                handleOnClick={(val: any) => setFilterOpen(val)}
                onSortingChange={onSortingChange}
                sortingOption={sortingOption}
                variant={variant}
                asInputField={asInputField}
            />
        </FiltersContainer>
    );
};

export default Filters;
